import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';
import { GLAccountBalanceDTO } from '@manager-base/applicants/data/dtos/gl-account-balance-dto';
import { ApplicationBalanceSummaryDTO } from '@manager-base/applicants/data/dtos/application-balance-summary-dto';

const actions = {
    get: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationFinancials/:id`,
    },
    getApplicantLedgerBalance: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationFinancials/:applicationId/balances`,
    },
    getLedgerByDate: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationFinancials/:applicationId/ledgerByDate`,
        params: {
            '$count': true
        }
    },
    getLedgerByAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationFinancials/:applicationId/ledgerByAccount`,
        params: {
            '$count': true
        }
    },
    deleteLedgerTransaction: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/applicationFinancials/:applicationId/transaction/:journalId`
    },
    getApplicantLedgerBalanceForRefunds: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationFinancials/:applicationId/balances/refund`,
    },
    getApplicantDeposits: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationFinancials/:applicationId/deposits`,
        params: {
            '$count': true
        }
    },
    getApplicationBalanceSummary: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationFinancials/:applicationId/balanceSummary`
    },
    hasLedgerTransactions: {
        method: 'GET',
        url: `${BASE_PATH_API}/applicationFinancials/:applicationId/hasLedgerTransactions`
    }
};

export interface IApplicationFinancialsApi {
    // eslint-disable-next-line id-blacklist
    get(params: { id: number }): Promise<any>
    getApplicantLedgerBalance(params: any): Promise<any>
    getLedgerByDate(params: { skip?: number, take?: number, orderBy?: string, orderByAscending?: boolean, applicationId: number }): Promise<any>
    getLedgerByAccount(params: { skip?: number, take?: number, orderBy?: string, orderByAscending?: boolean, applicationId: number }): Promise<any>
    deleteLedgerTransaction(request: any): Promise<any>
    getApplicantLedgerBalanceForRefunds(params: { applicationId: number }): Promise<GLAccountBalanceDTO[]>
    getApplicantDeposits(params: { skip?: number, take?: number, orderBy?: string, orderByAscending?: boolean, applicationId: number }): Promise<any>
    getApplicationBalanceSummary(params: { applicationId: number }): Promise<ApplicationBalanceSummaryDTO>
}

// eslint-disable-next-line prefer-arrow/prefer-arrow-functions
export function ApplicationFinancialsApi(): IApplicationFinancialsApi {
    return createActions(actions);
}
